export let markers = [];
export let deduplicatedMarkers = [];
// let markers2 = [];
// export let visibleCopy = [];

const getUniqueObjects = (data, key) => [
  ...new Map(data.map((x) => [key(x), x])).values(),
];

const createMarker = (properties) => {
  return new window.google.maps.Marker({
    position: { lat: +properties.latitude, lng: +properties.longitude },
    title: properties.location_title,
    visible: true,
  });
};

export const getLocations = (workshops) =>
  getUniqueObjects(workshops, (ws) => ws.workshop_location_id);

export const addMarkers = ({ workshops }) => {
  markers = workshops.map((workshop, index) => ({
    id: index,
    workshop: workshop,
    googleObj: createMarker(workshop),
    position: { lat: +workshop.latitude, lng: +workshop.longitude },
    title: workshop.location_title,
  }));
  // markers2 = workshops.map((workshop, index) => ({
  //   id: index,
  //   workshop: workshop,
  //   googleObj: createMarker(workshop),
  //   position: { lat: +workshop.latitude, lng: +workshop.longitude },
  //   title: workshop.location_title,
  // }));
  deduplicatedMarkers = getUniqueObjects(
    markers,
    (marker) => marker.workshop.workshop_location_id,
  );
  // visibleCopy = getUniqueObjects(
  //   markers2,
  //   (marker) => marker.workshop.workshop_location_id
  // );
  // for (let i = 0; i < visibleCopy.length; i++) {
  //   visibleCopy[i].googleObj.visible = true;
  // }
};
